import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { SweetAlertService } from '../../services/sweet-alert.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../login.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-pass-dialog',
  standalone: true,
  imports: [
    MatCardModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    CommonModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  templateUrl: './reset-pass-dialog.component.html',
  styleUrl: './reset-pass-dialog.component.scss'
})
export class ResetPassDialogComponent implements OnInit {
  form!: FormGroup
  showPassword: boolean = false
  showConfirmPassword: boolean = false
  isSubmitting: boolean = false
  constructor(private dialog: MatDialog,
    private dialogRef: MatDialogRef<ResetPassDialogComponent>,
    private fb: FormBuilder,
    private authService: LoginService,
    private sweetAlert: SweetAlertService,
    private authenticationService: AuthenticationService,
    private router: Router,

    private toaster: ToastrService) {

  }
  ngOnInit() {
    this.form = this.fb.group({
      password: new FormControl("", [Validators.required, Validators.minLength(6), this.passwordValidator]),
      confirmPassword: new FormControl('', [Validators.required]),
    }, { validators: this.matchPasswordsValidator('password', 'confirmPassword') })
  }
  private passwordValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';

    const errors: any = {};

    if (!/[A-Z]/.test(value)) {
      errors.noUpperCase = true;
    }

    if (!/[a-z]/.test(value)) {
      errors.noLowerCase = true;
    }

    if (!/[0-9]/.test(value)) {
      errors.noNumber = true;
    }

    if (!/[\W_]/.test(value)) {
      errors.noSymbol = true;
    }

    return Object.keys(errors).length ? errors : null;
  }
  private matchPasswordsValidator(password: string, confirmPassword: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const pass = formGroup.get(password)?.value;
      const confirm = formGroup.get(confirmPassword)?.value;

      if (pass !== confirm) {
        formGroup.get(confirmPassword)?.setErrors({ passwordsMismatch: true });
        return { passwordsMismatch: true };
      } else {
        const errors = formGroup.get(confirmPassword)?.errors;
        if (errors) {
          delete errors['passwordsMismatch'];
          if (!Object.keys(errors).length) {
            formGroup.get(confirmPassword)?.setErrors(null);
          }
        }
        return null;
      }
    };
  }
  onShowPassword(type: string) {
    if (type === 'password') {
      this.showPassword = !this.showPassword
    } else {
      this.showConfirmPassword = !this.showConfirmPassword
    }
  }
  onSubmit() {
    console.log("Form values: ", this.form.value)
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return
    }
    const payload = {
      password: this.form.get('password')?.value as string,
      confirmedPassword: this.form.get('confirmPassword')?.value as string
    }
    this.isSubmitting = true
    this.authService.resetUserPassword(payload).subscribe({
      next: (res: any) => {
        console.log("Server Response: ", res)
        this.toaster.success(`${res?.statusDescription} and you will be logged out` || "Sucessfull password change and you will be logged out")
        this.isSubmitting = false
        setTimeout(() => {
          this.logout()
        }, 2000)
      },
      error: (err) => {
        console.log("Error: ", err)
        this.isSubmitting = false
      }
    })
  }
  logout() {
    this.dialogRef.close()
    this.authenticationService.logout();
    this.toaster.success("You were loged out.!");
    this.router.navigate(["/authentication"]);
  }
}
